'use client';

import Link from 'next/link';

import { useIsEmbed } from '@/contexts/embed';
import { ChevronDown } from '@/icons';

export const TermsLinkRow = ({
  href,
  title,
  description,
}: {
  href: string;
  title: string;
  description?: string;
}) => {
  // A terms page answers with frame-ancestors 'self', so inside an embed it
  // opens in its own tab rather than blanking the widget.
  const isEmbed = useIsEmbed();

  return (
    <Link
      href={href}
      target={isEmbed ? '_blank' : undefined}
      className="mb-focus-visible group -mx-3 flex items-center gap-3 rounded-xl px-3 py-4 transition-colors duration-200 hover:bg-gray-50"
    >
      <span className="flex min-w-0 flex-1 flex-col gap-1.5">
        <span className="text-base font-semibold text-gray-900 transition-colors duration-200 group-hover:text-red-400">
          {title}
        </span>
        {description && (
          <span className="text-sm text-gray-600">{description}</span>
        )}
      </span>
      <span
        className="inline-flex shrink-0 transition-transform duration-300 ease-in-out group-hover:translate-x-1"
        aria-hidden
      >
        <ChevronDown rotate={-90} className="h-5 w-5 text-red-400" />
      </span>
    </Link>
  );
};
